<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-10">
                    <h1>{{ 'general.companies' | lang }}</h1>
                </div>
                <div class="col-md-2">
                    <a href="" @click.prevent="onAction(undefined)">
                        <button type="button" name="button" class="btn btn-primary btn-block">
                            {{ 'actions.create' | lang }}
                        </button>
                    </a>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <TLoader :loading="isBusy"/>
            <div class="row">
                <div class="col-12">
                    <div class="card mt-2">
                        <div class="card-body">
                            <BTable
                                    show-empty
                                    :responsive="true"
                                    :items="provider"
                                    :busy.sync="isBusy"
                                    :fields="fields"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    ref="table"
                            >
                                <template v-slot:cell(created_at)="data">
                                    {{ timeSinceTimestamp(data.item.created_at) }}
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <template v-for="action in data.item.actions">
                                        <a :href="action.url" class="mr-2" @click.prevent="onAction(data.item)">{{
                                            action.action | lang }}</a>
                                    </template>
                                </template>
                            </BTable>
                            <BPagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    aria-controls="my-table"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CompanyEditorModal ref="modal" @interface="companyUpdated" :company="currentCompany"/>
    </div>
</template>

<script>
  import moment from 'moment';
  import axios from 'axios';

  export default {
    name: 'CompanyIndex',
    props: {
      index: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        currentCompany: {},
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        isBusy: false,
        fields: [
          {key: 'name', label: 'Name'},
          {key: 'created_at', label: 'Created at'},
          {key: 'actions', label: 'Actions'},
        ],
      };
    },
    methods: {
      timeSinceTimestamp(ts) {
        return moment(ts).fromNow();
      },
      provider(ctx) {
        const url = `${this.index}?page=${ctx.currentPage}&size=${ctx.perPage}`;
        let promise = axios.get(url);

        return promise.then((response) => {
          const data = response.data.data;
          const meta = response.data.meta;
          this.currentPage = meta.current_page;
          this.totalRows = meta.total;

          return data;
        }).catch(error => {
          return [];
        });
      },
      onAction(company) {
        this.currentCompany = company || {};
        $(this.$refs.modal.$el).modal('show');
      },
      companyUpdated(company) {
        this.currentCompany = company || {};
        $(this.$refs.modal.$el).modal('hide');
        this.refresh();
      },
      refresh() {
        this.$nextTick(() => {
          this.$refs.table.refresh();
        });
      },
    },
  };
</script>
